import React from 'react';
import {Provider} from "react-redux";
import configure from "../../../../store/configure";
import './SelfMessageCreatePage.css'
import SelfMessageCreateContainer from "../container/SelfMessageCreateContainer";
import Layout from "../../../../component/layout/Layout";

const SelfMessageCreatePage = () => {

    return (
        <Provider store={configure}>
            <Layout>
                <SelfMessageCreateContainer />
            </Layout>
        </Provider>
    );
};

export default SelfMessageCreatePage;
